module.exports = __webpack_public_path__ + "herominecraftwp3eb6eba9d1bce70fbfb30d379f61eb77.png";